<script setup lang="ts">
	import {computed} from 'vue';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	const emit = defineEmits(['click']);
	
	const props = defineProps({
		progress: Boolean,
		icon: String
	});

	const buttonClass = computed(() => {
		return props.progress ? "uploadingIcon" : "";
	});
		
	const iconName = computed(() => {
		return props.progress ? "gear" : props.icon;
	});
</script>
<template>
	<button :disabled="progress" @click="$emit('click')" >
		<span style="padding-right: 10px;"><slot></slot></span>
		<sym-icon :name="iconName" :class="buttonClass" />
	</button>
</template>

